import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { TrashCanFull } from '../../../icons'
import { useWindowSize } from '../../../libs/hooks'
import Dropdown from '../../common/Dropdown'
import PriceInput from '../../common/PriceInput'
import { loadTrials } from '../../../actions/businessRules'

const FormDigitalProductPrice = (props) => {
  const { t } = useTranslation()
  const isMobile = useWindowSize()[0] <= 768
  const { isEditMode, pricesFormData, productPricesErrors, countries, resetPricesErrors, updatePrices } = props
  const [trialsOptions, setTrialsOptions] = useState([])

  useLayoutEffect(() => {
    if (pricesFormData.length === 0) {
      const newPrice = {
        amount: '',
        currencyCode: '',
        countryCode: '',
        trialBusinessRuleId: null,
        recurrenceInterval: null,
        recurrenceIntervalCount: null,
      }

      updatePrices([newPrice])
    }
  }, [pricesFormData])

  useLayoutEffect(() => {
    if (props.priceTrials === 0) {
      props.actions.loadTrials({ isEnabled: true }, true)
    }
  }, [props.actions])

  useEffect(() => {
    if (props.priceTrials.length > 0) {
      const trials = props.priceTrials.map((trial) => {
        return { id: trial.id, name: trial.name }
      })

      setTrialsOptions(trials)
    }
  }, [props.priceTrials])

  const selectCountry = (countryCode, idx) => {
    const country = countries.find((c) => c.countryCode === countryCode)

    if (!country) {
      return
    }

    const updatedPrices = pricesFormData.map((price, index) => {
      if (index === idx) {
        return { ...price, countryCode: country.countryCode, currencyCode: country.currencyCode }
      }

      return price
    })

    updatePrices(updatedPrices)
  }

  const selectTrialBusinessRule = (trialBusinessRuleId, idx) => {
    const updatedPrices = pricesFormData.map((price, index) => {
      if (index === idx) {
        return { ...price, trialBusinessRuleId: trialBusinessRuleId }
      }

      return price
    })

    updatePrices(updatedPrices)
  }

  const handleAddPrice = () => {
    const newPrice = {
      amount: '',
      currencyCode: '',
      countryCode: '',
      trialBusinessRuleId: null,
      recurrenceInterval: null,
      recurrenceIntervalCount: null,
    }

    updatePrices([...pricesFormData, newPrice])
  }

  const handleRemovePrice = (idx) => {
    const newPrices = pricesFormData.filter((price, index) => idx !== index)

    resetPricesErrors()
    updatePrices(newPrices)
  }

  const handleChangeAmount = (amount, idx) => {
    const updatedPrices = pricesFormData.map((price, index) => {
      if (index === idx) {
        return { ...price, amount: amount }
      }

      return price
    })

    updatePrices(updatedPrices)
  }

  return (
    <div className="price-plans-wrapper">
      {pricesFormData.map((price, index) => (
        <div key={index} className={`prices-options-wrapper ${isMobile && 'flex-column'} ${isMobile && index !== 0 && 'with-big-margin-top'}`}>
          <div className="fixed-input-wrapper one-third-wrapper">
            <div className="input-label">
              {t('country')}
              <span className="required-mark">*</span>
            </div>
            <div className="title-with-action-wrapper-mobile">
              <Dropdown
                options={countries.map((option) => ({
                  key: option.countryCode,
                  value: option.countryName,
                  isDisabled: pricesFormData.some((p) => p.countryCode === option.countryCode),
                }))}
                initialSelectedKey={pricesFormData[index].countryCode}
                onChange={(item) => selectCountry(item.key, index)}
                hasError={productPricesErrors?.includes(`digital-${index}-countryCode`)}
                isDisabled={isEditMode && pricesFormData[index].id}
              />
              {isMobile && (
                <div className="delete-option-wrapper">
                  <TrashCanFull
                    onClick={() => {
                      handleRemovePrice(index)
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={'fixed-input-wrapper one-third-wrapper' + (isMobile ? ' with-reduced-width' : '')}>
            <div className="input-label">
              {t('coltene_store.create_product.price')}
              <span className="required-mark">*</span>
            </div>
            <PriceInput
              value={price.amount}
              hasError={productPricesErrors?.includes(`digital-${index}-amount`)}
              onChange={(value) => handleChangeAmount(value, index)}
              currency={price.currencyCode}
            />
          </div>
          <div className={'fixed-input-wrapper with-flex-grow' + (isMobile ? ' with-reduced-width' : '')}>
            <div className="input-label">{t('coltene_store.create_product.business-rule')}</div>
            <Dropdown
              options={trialsOptions.map((option) => ({ key: option.id, value: option.name }))}
              initialSelectedKey={pricesFormData[index].trialBusinessRuleId}
              onChange={(item) => selectTrialBusinessRule(item.key, index)}
              hasError={productPricesErrors?.includes(`digital-${index}-trialBusinessRuleId`)}
            />
          </div>
          {!isMobile && (
            <div className="delete-option-wrapper">
              <TrashCanFull
                onClick={() => {
                  handleRemovePrice(index)
                }}
              />
            </div>
          )}
        </div>
      ))}
      {pricesFormData.length < countries.length && (
        <div className="add-option-wrapper" onClick={() => handleAddPrice()}>
          {`+  ${t('coltene_store.create_product.add-new-country')}`}
        </div>
      )}
    </div>
  )
}

function stateToProps({ businessRules }) {
  return {
    priceTrials: businessRules?.trials || [],
  }
}

function dispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadTrials,
      },
      dispatch,
    ),
  }
}

export default connect(stateToProps, dispatchToProps)(FormDigitalProductPrice)
